<template>
  <v-expansion-panels v-model="panel" multiple color="#fff">
    <v-expansion-panel>
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
        <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
        <h3>{{ abutmentType }} Abutment</h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text v-if="!substructureUnit">
        <v-row align="center">
          <v-col>
            <v-label class="noRecordsMessage d-flex justify-center"
              >This structure currently contains no {{ abutmentType }} Abutment.
            </v-label>
          </v-col>
        </v-row>
      </v-expansion-panel-text>
      <v-expansion-panel-text v-if="substructureUnit">
        <v-expansion-panels v-model="subPanel" multiple color="#fff">
          <v-expansion-panel v-if="substructureUnit">
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!subPanel.includes(0)" icon="fa-solid fa-plus" />
              <v-icon v-if="subPanel.includes(0)" icon="fa-solid fa-minus" />
              <h3>{{ abutmentType }} Abutment Inspection Notes</h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    id="btn_copyCurrentToTarget"
                    variant="outlined"
                    class="my-2"
                    :disabled="!isEditable"
                    @click="copyCurrentToTarget"
                    >Copy Abutment Notes</v-btn
                  >
                </v-col>
              </v-row>
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_backwall_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.BACKWALL"
                :readOnly="!isEditable"
                label="Backwall"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_bridge_seats_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.BRIDGE_SEATS"
                :readOnly="!isEditable"
                label="Bridge Seats"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_cheekwalls_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.CHEEKWALLS"
                :readOnly="!isEditable"
                label="Cheekwalls"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_stem_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.STEM"
                :readOnly="!isEditable"
                label="Stem"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_wings_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.WINGS"
                :readOnly="!isEditable"
                label="Wings"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_footing_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.FOOTING"
                :readOnly="!isEditable"
                label="Footing"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_piles_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.PILES"
                :readOnly="!isEditable"
                label="Piles"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_settlement_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.SETTLEMENT"
                :readOnly="!isEditable"
                label="Settlement"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_embank_slope_wall_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.EMBANK_SLOPE_WALL"
                :readOnly="!isEditable"
                label="Embank Slope-Wall"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                :id="`textarea_wall_drainage_${abutmentType}`"
                :inspectionCommentType="INSPECTION_COMMENTS.WALL_DRAINAGE"
                :readOnly="!isEditable"
                label="Wall Drainage"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="substructureUnit.structureUnitId"
                @updateComment="handleUpdate()"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel
            v-if="isStructureUnitIn500YrFp(substructureUnit.strUnitKey, substructureValue.inspectionsUnderwater)"
          >
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!subPanel.includes(1)" icon="fa-solid fa-plus" />
              <v-icon v-if="subPanel.includes(1)" icon="fa-solid fa-minus" />
              <h3>{{ abutmentType }} Abutment – Waterway</h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <UnderwaterInspection
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                ref="underwaterInsp"
                :isEditable="isEditable"
                :id="`abutment_${substructureUnit?.strUnitKey}_Underwater`"
                :strUnitKey="substructureUnit.strUnitKey"
                :strUnitLabel="substructureUnit.strUnitLabel"
                :legacyStructureType="substructureUnit.legacyStructureType"
                @updateUnderwaterInspection="handleUpdate()"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="substructureUnit">
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!subPanel.includes(subPanelValue)" icon="fa-solid fa-plus" />
              <v-icon v-if="subPanel.includes(subPanelValue)" icon="fa-solid fa-minus" />
              <h3>{{ abutmentType }} Abutment – NSTM/Fatigue</h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <NSTMFatigueTable
                :id="`Abutment_NSTMFatigue_Table_${abutmentType}`"
                substructureFatigueTable
                spanBySpanFatigueTable
                :unitKey="substructureUnit.strUnitKey"
                :moduleType="moduleType"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { computed, ref, watch } from "vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import UnderwaterInspection from "@/components/inspection/substructureComponents/UnderwaterInspection.vue";
import { INSPECTION_COMMENTS, SUB_STRUCTURE_UNIT_KEY, INSPECTION_PAGES } from "@/constants/Inspections";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import NSTMFatigueTable from "@/components/shared/NSTMFatigueTable.vue";
import { useSnackbarStore } from "@/stores/snackbar";
import { isStructureUnitIn500YrFp } from "@/composables/waterways.js";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useSubstructureStore } from "@/components/inspection/store/substructure";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";

export default {
  name: "AbutmentComponent",
  props: {
    id: {},
    abutmentType: { default: "" },
    unitKey: { default: "" },
    isExpanded: { default: true },
    isEditable: { default: false },
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const substructureStore = useSubstructureStore();
    const inspectionLinksStore = useInspectionLinksStore();

    let substructureValue = computed(() => substructureStore.pageData);
    const configStore = useConfigStore();
    const commentTypes = [
      INSPECTION_COMMENTS.BACKWALL,
      INSPECTION_COMMENTS.BRIDGE_SEATS,
      INSPECTION_COMMENTS.CHEEKWALLS,
      INSPECTION_COMMENTS.STEM,
      INSPECTION_COMMENTS.WINGS,
      INSPECTION_COMMENTS.FOOTING,
      INSPECTION_COMMENTS.PILES,
      INSPECTION_COMMENTS.SETTLEMENT,
      INSPECTION_COMMENTS.EMBANK_SLOPE_WALL,
      INSPECTION_COMMENTS.WALL_DRAINAGE,
      INSPECTION_COMMENTS.COMBUSTIBLE_MATERIAL,
    ];

    const inspectionStore = useInspectionStore();
    const snackbarStore = useSnackbarStore();
    const subUnitLabel = computed(() => {
      if (props.abutmentType == "Far") {
        return SUB_STRUCTURE_UNIT_KEY.FAR_ABUTMENT;
      } else {
        return SUB_STRUCTURE_UNIT_KEY.NEAR_ABUTMENT;
      }
    });
    const substructureUnit = computed({
      get() {
        return substructureValue.value?.structureUnits?.find(
          (elementToFind) => elementToFind?.strUnitKey == props?.unitKey
        );
      },
    });

    let underwaterInsp = ref(null);
    let subPanelValue = ref(
      isStructureUnitIn500YrFp(substructureUnit.value?.strUnitKey, substructureValue.value.inspectionsUnderwater)
        ? 2
        : 1
    );
    async function validate() {
      if (isStructureUnitIn500YrFp(substructureUnit.value?.strUnitKey, substructureValue.value.inspectionsUnderwater)) {
        await underwaterInsp.value.validate();
        return underwaterInsp.value.valid;
      } else {
        return true;
      }
    }
    let snackBarId = ref("");
    let snackBarIdenticalId = ref("");

    const panel = ref([0]);
    const subPanel = ref([0, 1, 2]);
    if (!substructureUnit.value) {
      panel.value = [];
      subPanel.value = [];
    }

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    function onHideSnackbar() {
      snackbarStore.removeMessage(snackBarId.value);
      snackbarStore.removeMessage(snackBarIdenticalId.value);
    }
    function copyCurrentToTarget() {
      let editOccurred = false;
      let targetId;
      if (subUnitLabel.value == SUB_STRUCTURE_UNIT_KEY.NEAR_ABUTMENT) {
        targetId = substructureValue.value?.structureUnits?.find(
          (elementToFind) => elementToFind?.strUnitLabel == "FAB"
        ).structureUnitId;
      } else {
        targetId = substructureValue.value?.structureUnits?.find(
          (elementToFind) => elementToFind?.strUnitLabel == "NAB"
        ).structureUnitId;
      }
      for (const commentType of commentTypes ?? []) {
        let currentIndex = substructureValue.value?.structureUnitInspComments.findIndex(
          (element) =>
            element?.structureUnitId == substructureUnit.value.structureUnitId && element?.commentType == commentType
        );
        let targetIndex = substructureValue.value?.structureUnitInspComments.findIndex(
          (element) => element?.structureUnitId == targetId && element?.commentType == commentType
        );
        if (
          currentIndex != -1 &&
          targetIndex != -1 &&
          substructureValue.value.structureUnitInspComments[targetIndex].notes !=
            substructureValue.value.structureUnitInspComments[currentIndex].notes
        ) {
          substructureValue.value.structureUnitInspComments[targetIndex].notes =
            substructureValue.value.structureUnitInspComments[currentIndex].notes;
          substructureValue.value.structureUnitInspComments[targetIndex].updateDateTime = null;
          editOccurred = true;
        } else if (targetIndex == -1 && currentIndex != -1 && targetId) {
          substructureValue.value.structureUnitInspComments.push({
            brkey: substructureValue.value.brkey,
            commentType: commentType,
            inspectionId: substructureValue.value.inspectionId,
            updateDateTime: null,
            notes: substructureValue.value.structureUnitInspComments[currentIndex].notes,
            structureUnitId: targetId,
            updateUserId: null,
          });
          editOccurred = true;
        } else if (targetIndex != -1 && currentIndex == -1) {
          substructureValue.value.structureUnitInspComments[targetIndex].notes = "";
          substructureValue.value.structureUnitInspComments[targetIndex].updateDateTime = null;
          editOccurred = true;
        }
      };
      setCopyToTargetSnackbar(editOccurred);
    }

    const setCopyToTargetSnackbar = (editOccurred) => {
      if (editOccurred) {
        if (subUnitLabel.value == SUB_STRUCTURE_UNIT_KEY.FAR_ABUTMENT) {
          snackBarId.value = snackbarStore.showMessage({
            displayText: "Abutment Notes copied from Far Abutment to Near Abutment. You must save to keep the changes.",
            timeout: 3000,
            callback: onHideSnackbar,
          });
        } else {
          snackBarId.value = snackbarStore.showMessage({
            displayText: "Abutment Notes copied from Near Abutment to Far Abutment. You must save to keep the changes.",
            timeout: 3000,
            callback: onHideSnackbar,
          });
        }
      } else {
        snackBarIdenticalId.value = snackbarStore.showMessage({
          displayText: "Near and Far Abutment Notes are identical.",
          timeout: 3000,
          callback: onHideSnackbar,
        });
      }
    };

    const handleUpdate = () => {
      if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
        inspectionLinksStore.isDirty = true;
      } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
        inspectionStore.setDirtyFlag(true);
      }
    };

    watch(
      () => [props.isExpanded],
      () => {
        if (props.isExpanded) {
          panel.value = [0];
        } else {
          panel.value = [];
        }
      }
    );

    watch(
      () => [substructureValue.value],
      () => {
        if (substructureUnit.value) {
          panel.value = [0];
          subPanel.value = [0, 1, 2];
        } else {
          panel.value = [];
          subPanel.value = [];
        }
      }
    );

    return {
      handleUpdate,
      INSPECTION_PAGES,
      substructureValue,
      MODULE_TYPES,
      isStructureUnitIn500YrFp,
      substructureUnit,
      validate,
      underwaterInsp,
      subPanel,
      subUnitLabel,
      copyCurrentToTarget,
      commentsMaxLength,
      REFERENCE_TABLE,
      panel,
      inspectionStore,
      INSPECTION_COMMENTS,
      SUB_STRUCTURE_UNIT_KEY,
      subPanelValue,
      onHideSnackbar,
    };
  },
  components: {
    UnderwaterInspection,
    StructureUnitCommentTypeTextField,
    NSTMFatigueTable,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
</style>
